import { render, staticRenderFns } from "./AppButtonShipment.vue?vue&type=template&id=1c2dad85&scoped=true&"
import script from "./AppButtonShipment.vue?vue&type=script&lang=ts&"
export * from "./AppButtonShipment.vue?vue&type=script&lang=ts&"
import style0 from "./AppButtonShipment.vue?vue&type=style&index=0&id=1c2dad85&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c2dad85",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
installComponents(component, {VBtn})
